import React, { useState } from "react";
import styles from "./style.module.css";
import { Button, Input, Textarea } from "@chakra-ui/react";
import { message } from "antd";

import { ImAttachment } from "react-icons/im";
import { db } from "../../../Firebase_config";
import { addDoc, collection } from "firebase/firestore";
import { useLocation, useNavigate } from "react-router-dom";
import { fileRequest } from "../../../requestMethod";
const initialState = {
  title: "",
  subject: "",
  Msg: "",
  document: "",
};

const CreateMassage = ({ setCreate }) => {
  const [form, setForm] = useState(initialState);
  const navigate = useNavigate();
  const id = JSON.parse(localStorage.getItem("userId"));
  const senderName = JSON.parse(localStorage.getItem("userName"));
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const chatId = queryParams.get("chatId");

  const addData = async () => {
      if (!form.subject) {
        message.error("Enter subject");
      } else {
        if (!form.Msg) {
          message.error("Select Msg");
        } else {
          setForm(initialState);

          try {
            await addDoc(
              collection(
                db,
                `Chats/${id}/chatUser/${`64ad2c90799b1826afb2c51a`}/${chatId}`
              ),
              {
                Msg: form.Msg,
                sender_name: senderName,
                receiver_name: "Admin",

                document: form.document ? form.document : false,
                subject: form.subject,
                from: id,
                msgSeen: false,
                timestamp: new Date().toISOString(),
              }
            );

            await addDoc(collection(db, `outbox/${id}/chatUser`), {
              id: chatId,
              sender_name: senderName,
              receiver_name: "Admin",
              to: "64ad2c90799b1826afb2c51a",
              Msg: form.Msg,
              document: form.document ? form.document : false,
              subject: form.subject,
              from: id,
              sender: true,
              receiver: false,
              timestamp: new Date().toISOString(),
            });

            await addDoc(
              collection(db, `inbox/${`64ad2c90799b1826afb2c51a`}/chatUser`),
              {
                id: chatId,
                to: "64ad2c90799b1826afb2c51a",
                Msg: form.Msg,
                sender_name: senderName,
                receiver_name: "Admin",
                document: form.document ? form.document : false,
                subject: form.subject,
                from: id,
                sender: true,
                receiver: false,
                timestamp: new Date().toISOString(),
              }
            );
            message.success("Message sent to admin successfully");
            navigate("/Messages");
          } catch (error) {
            console.error("Error adding new document: ", error);
          }
        }
      }

  };
  const upload = async (e) => {
    const formData = new FormData();
    const image = e.target.files[0]; // Get the first selected file from the array

    if (image) {
      formData.append("file", image);

      // Append the selected file to the FormData

      fileRequest
        .post("/api/util/uploadFile", formData)
        .then((res) => {
          console.log("res:", res.data.url);
          setForm({ ...form, document: res.data.url });
          message.success("File uploaded successfully");
        })
        .catch((err) => {
          console.log(err);
          message.error("File upload failed");
        });
    }
  };
  function getFileNameFromURL(url) {
    const parts = url.split("/");
    const filename = parts[parts.length - 1];
    return filename;
  }
  return (
    <div className={styles.MainContainer}>
      <div className={styles.container1}>
        <span>
          All Messages {">"}{" "}
          <b style={{ opacity: "100%", color: "#131313" }}>Create Message</b>
        </span>
        <h1>New Message</h1>

        <div className={styles.resetPassword}>
          <p>Subject*</p>
          <Input
            maxLength={150}
            placeholder="Add Body (max. 150 characters)"
            value={form.subject}
            onChange={(e) => setForm({ ...form, subject: e.target.value })}
          />
          <p>Message*</p>
          <Textarea
            maxLength={250}
            placeholder="Add Message (max. 250 characters)"
            rows={5}
            value={form.Msg}
            onChange={(e) => setForm({ ...form, Msg: e.target.value })}
          />
          <p>Attach files</p>
          <span className={styles.attachSpan}>
            <p>{getFileNameFromURL(form.document)}</p>
            <label htmlFor="main">
              <ImAttachment />
            </label>
            <input
              type="file"
              id="main"
              onChange={(e) => upload(e)}
              style={{ display: "none" }}
            />
          </span>
        </div>
      </div>
      <div className={styles.btn}>
        <Button
          colorScheme="black"
          variant="outline"
          w="127px"
          onClick={() => navigate("/Messages")}
        >
          Cancel
        </Button>
        <Button
          bg="black"
          color="#fff"
          variant="solid"
          w="147px"
          onClick={addData}
        >
          Send Message
        </Button>
      </div>
    </div>
  );
};

export default CreateMassage;
